import validate from "/frontend/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@8.57.0_ioredis@_4c07faf7cec08ced500b9013c3717441/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/frontend/middleware/auth.global.ts";
import web_45global from "/frontend/middleware/web.global.ts";
import manifest_45route_45rule from "/frontend/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@8.57.0_ioredis@_4c07faf7cec08ced500b9013c3717441/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  web_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}